import { render, staticRenderFns } from "./pc-table.vue?vue&type=template&id=7ecb9088&scoped=true"
import script from "./pc-table.vue?vue&type=script&lang=js"
export * from "./pc-table.vue?vue&type=script&lang=js"
import style0 from "./pc-table.vue?vue&type=style&index=0&id=7ecb9088&prod&scoped=true&lang=css"
import style1 from "./pc-table.vue?vue&type=style&index=1&id=7ecb9088&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ecb9088",
  null
  
)

export default component.exports